import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 create_promotion: { message: "idle" },
};

export const create_promotion_Slice = createSlice({
 name: "create_promotion",
 initialState,
 reducers: {
  success_create_promotion: (state, action) => {
   state.create_promotion = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_create_promotion: (state, action) => {
   state.create_promotion = { status: app_consts.FAIL, message: action.payload };
  },
  reset_create_promotion: (state) => {
   state.create_promotion = { status: app_consts.IDLE };
  },
  loading_create_promotion: (state) => {
   state.create_promotion = { status: app_consts.LOADING };
  },
 }
});

export const { success_create_promotion, fail_create_promotion, reset_create_promotion, loading_create_promotion } = create_promotion_Slice.actions;

export default create_promotion_Slice.reducer;